import { ReactNode, useCallback } from 'react';
import {
  NonStructuredCertificateStudentsFilters,
  NonStructuredCertificateStudentsResponse,
} from '../types';
import { getCertificateStudents } from '../api';
import { useParams } from 'react-router-dom';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';

const {
  FetchProvider: CertificateStudentsProvider,
  useFetch: useCertificateStudents,
} = createFetchContext<
  NonStructuredCertificateStudentsFilters,
  NonStructuredCertificateStudentsResponse
>();

interface Props {
  children: ReactNode;
  defaultQuery?: NonStructuredCertificateStudentsFilters;
  fetchImmediately?: boolean;
}

export const CertificateStudentsLoader = ({
  children,
  defaultQuery = { page: 1, items_per_page: 10 },
  fetchImmediately = true,
}: Props) => {
  const { ceAcademicOfferId } = useParams<{ ceAcademicOfferId: string }>();

  const requestFn = useCallback(
    (filters?: NonStructuredCertificateStudentsFilters) =>
      getCertificateStudents(Number(ceAcademicOfferId), filters ?? {}),
    [ceAcademicOfferId],
  );

  return (
    <CertificateStudentsProvider
      request={requestFn}
      defaultQuery={defaultQuery}
      fetchImmediately={fetchImmediately}
    >
      {children}
    </CertificateStudentsProvider>
  );
};

export { useCertificateStudents };
